import { Injectable } from "@angular/core";
import { IAddressValidationModel, IShippingAddressModel } from "@models";
import { HttpService } from "./utils/http.service";

@Injectable()
export class TaxRatesService {
	constructor(private httpService: HttpService) { }

	// Returns null when the company isn't on CereTax or the address is too sparse to submit.
	async validateAddress(shippingAddress: IShippingAddressModel): Promise<IAddressValidationModel> {
		return await this.httpService.post(`/taxRates/validateAddress`, shippingAddress);
	}
}
